import { render, staticRenderFns } from "./AffiliateDetails.vue?vue&type=template&id=3a9dd2d4&scoped=true"
import script from "./AffiliateDetails.vue?vue&type=script&lang=js"
export * from "./AffiliateDetails.vue?vue&type=script&lang=js"
import style0 from "./AffiliateDetails.vue?vue&type=style&index=0&id=3a9dd2d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9dd2d4",
  null
  
)

export default component.exports